var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeAtivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "Hawkins-Icon Hawkins-Icon-Standard",
    "data-name": "RateUpFill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m13.407 6.256-.094-.752A2.859 2.859 0 0 0 10.476 3a.476.476 0 0 0-.476.476v3.237a1 1 0 0 1-.152.53l-1.94 3.105a2 2 0 0 1-1.147.863l-2.036.582a1 1 0 0 0-.725.961v5.562c0 .378.306.684.684.684 1.19 0 2.36.31 3.393.901L8.25 20a7.59 7.59 0 0 0 3.766 1H16.5a1.5 1.5 0 0 0 1.118-2.5H18a1.5 1.5 0 0 0 .787-2.777 1.5 1.5 0 0 0-.287-2.973h-.17A1.499 1.499 0 0 0 17.5 10h-4.375l.282-2.256a5.998 5.998 0 0 0 0-1.488Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeAtivo);
export default __webpack_public_path__ + "static/media/like-ativo.15366d0139f1b67190dade2593da5bee.svg";
export { ForwardRef as ReactComponent };